export default __webpack_public_path__ + "static/media/location.7926130c.svg";